module.exports = __webpack_public_path__ + "components/star-rating/static/white/2-f283d6a1603ba330be09707485a36aa9.svg";